import { useTranslation } from "react-i18next";
import type { z } from "zod";

import { translateError } from "~/lib/errors";

type ErrorField = {
  code?: string | null;
  message: string;
  path: string;
};

export const useShowValidationErrors = <FormData>(
  setError: (
    name: keyof FormData,
    error: { type: string; message: string },
    config: {
      shouldFocus: boolean;
    },
  ) => void,
  keyTypeChecker: z.ZodType<keyof FormData>,
  showUnHandledErrorMessage?: (errorMessage: string) => void,
  excludedKeys?: (keyof FormData)[],
) => {
  const { t } = useTranslation();
  return (errors: ErrorField[]) => {
    const unHandledErrors: ErrorField[] = [];
    errors.forEach((error, i) => {
      const parseRet = keyTypeChecker.safeParse(error.path);
      const message = translateError(t, error);
      if (parseRet.success && (!excludedKeys || !excludedKeys.includes(parseRet.data))) {
        setError(parseRet.data, { type: "manual", message }, { shouldFocus: i === 0 });
      } else {
        unHandledErrors.push(error);
      }
    });

    if (showUnHandledErrorMessage) {
      showUnHandledErrorMessage(unHandledErrors.map((f) => `${f.code}: ${translateError(t, f)}`).join("\n"));
    }
  };
};
